import { useMemo, type ReactNode } from 'react';
import type { DiffereNavigationRequest, LibraryNavigationRequest } from '../../types/app';
import { isEmojiOnlyMessage } from '../../utils/chatMessage';
import { parseChatDeepLinks } from '../../utils/chatDeepLinks';
import ChatDeepLinkCard from './ChatDeepLinkCard';

interface ChatMessageContentProps {
  text: string;
  onOpenLibrary: (request: LibraryNavigationRequest) => void;
  onOpenDiffere: (request: DiffereNavigationRequest) => void;
  meta: ReactNode;
}

export default function ChatMessageContent({
  text,
  onOpenLibrary,
  onOpenDiffere,
  meta,
}: ChatMessageContentProps) {
  const { displayText, cards } = useMemo(() => parseChatDeepLinks(text), [text]);
  const cardsOnly = cards.length > 0 && !displayText;

  if (cards.length === 0) {
    return (
      <div className="message-footer">
        <span className={`message-text ${isEmojiOnlyMessage(text) ? 'emoji-only' : ''}`}>
          {text}
        </span>
        {meta}
      </div>
    );
  }

  return (
    <div className={`chat-message-content ${cardsOnly ? 'chat-message-content--cards-only' : ''}`}>
      {displayText && (
        <div className="message-footer message-footer--text-only">
          <span className={`message-text ${isEmojiOnlyMessage(displayText) ? 'emoji-only' : ''}`}>
            {displayText}
          </span>
        </div>
      )}

      <div className="chat-deep-link-cards">
        {cards.map((link, index) => (
          <ChatDeepLinkCard
            key={`${link.kind}-${index}`}
            link={link}
            onOpenLibrary={onOpenLibrary}
            onOpenDiffere={onOpenDiffere}
          />
        ))}
      </div>

      <span className="message-meta game-invite-meta">{meta}</span>
    </div>
  );
}
